import { html, ref, repeat, when } from '@microsoft/fast-element';
import { getPrefix } from '../utils/dom';
export const extractMenuItems = (items, prefix) => html `
  ${repeat(() => items, html `
      ${when((x) => x.isDisabled && x.isDisabled(), html `
          <${prefix}-menu-item class="menu-item" disabled>${(x) => x.name}</${prefix}-menu-item>
        `)}
      ${when((x) => !x.isDisabled || !x.isDisabled(), html `
          <${prefix}-menu-item
            class="menu-item"
            @click=${(x) => (!x.submenu ? x.callback() : '')}
            style="${(x) => (x.color ? `color: ${x.color};` : '')}"
          >
          ${when((x) => x.icon, html `
              <${prefix}-icon
                name=${(x) => x.icon.name}
                size=${(x) => x.icon.size}
                variant=${(x) => x.icon.variant}
                slot="start"
              ></${prefix}-icon>
            `)}
            ${(x) => x.name}
            ${when((x) => x.submenu, html `
                <${prefix}-menu>${(x) => extractMenuItems(x.submenu, prefix)}</${prefix}-menu>
              `)}
          </${prefix}-menu-item>
        `)}
    `)}
`;
export const getDropdownMenuTemplate = (prefix) => html `
  <div class="actions-container" part="actions-container">
    <${prefix}-button
      id="actiosnMenuTrigger"
      class="actions-opener"
      appearance="${(x) => x.buttonAppearance}"
      part="actions-opener"
      @click=${(x) => x.toggleDropdownMenuVisibility()}
      :disabled=${(x) => x.disabled}
    >
     <slot>${(x) => x.name}</slot>
    </${prefix}-button>
    <${prefix}-menu
      ${ref('dropdownMenu')}
      class="actions-menu ${(x) => x.classNames}"
      part="actions-menu"
    >
      ${(x) => extractMenuItems(x.allItems, prefix)}
    </${prefix}-menu>
  </div>
`;
export const foundationDropdownMenuTemplate = html `
  ${(x) => getDropdownMenuTemplate(getPrefix(x))}
`;
